import { render, staticRenderFns } from "./AdminNavigation.vue?vue&type=template&id=52ac8a18&"
import script from "./AdminNavigation.vue?vue&type=script&lang=ts&"
export * from "./AdminNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AdminNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports